export default __webpack_public_path__ + "static/media/Lexil - Case départ.b70d6d79.mp3";